import { render, staticRenderFns } from "./MoveIpPopup.vue?vue&type=template&id=605cf936&scoped=true"
import script from "./MoveIpPopup.vue?vue&type=script&lang=js"
export * from "./MoveIpPopup.vue?vue&type=script&lang=js"
import style0 from "./MoveIpPopup.vue?vue&type=style&index=0&id=605cf936&prod&lang=scss"
import style1 from "./MoveIpPopup.vue?vue&type=style&index=1&id=605cf936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605cf936",
  null
  
)

export default component.exports